import { render, staticRenderFns } from "./ProBadge.vue?vue&type=template&id=78c3038f"
import script from "./ProBadge.vue?vue&type=script&lang=js"
export * from "./ProBadge.vue?vue&type=script&lang=js"
import style0 from "./ProBadge.vue?vue&type=style&index=0&id=78c3038f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports